import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

const CRMMedicaidPending = loadable(
  () => import('@/pages/CRM/MedicaidPending')
); // prettier-ignore

export enum CRMMedicaidPendingRoutes {
  CRMMedicaidPending = '/crm/medicaid-pending'
}

export const getCrmMedicaidPendingRoutes = (): RouteObject[] => {
  return [
    {
      path: CRMMedicaidPendingRoutes.CRMMedicaidPending,
      element: <CRMMedicaidPending />
    }
  ];
};
